// extracted by mini-css-extract-plugin
export var oOurClients = "ourClients-module--o-ourClients--2Y8oX";
export var more = "ourClients-module--more--3Rd-K";
export var visible = "ourClients-module--visible--HytbW";
export var subcopyBefore = "ourClients-module--subcopy-before--1MuDf";
export var subcopyAfter = "ourClients-module--subcopy-after--2toIv";
export var standby = "ourClients-module--standby--2SZpY";
export var lContent__inner = "ourClients-module--l-content__inner--3yxUu";